<template>
  <div class="history">
    <component :is="componentName" v-if="privacyComponent"/>
    <Empty v-else-if="isLoaded" />
  </div>
</template>
<script>
import Empty from '@/components/Empty.vue'

export default {
  name: "History",
  components: { Empty },
  data () {
    return {
      privacyComponent: '',
      isLoaded: false
    }
  },
  computed: {
    componentName () {
      return this.privacyComponent || ''
    }
  },
  created () {
    const  { params: { version = '' }} = this.$route || {}
    if (!version) return
    this.loadPrivacy(version)
  },
  render: function(createElement) {
    return createElement(this.privacyComponent)
  },
  methods: {
    loadPrivacy (version) {
        const context = require.context('./components/', false,/\.vue$/)
        const isExist = Object.keys(context.keys()).length && (context.keys())?.includes(`./${version}.vue`)
        if (isExist) {
            const privacyComponent = (resolve) => require([`./components/${version}.vue`], resolve)
            this.privacyComponent = privacyComponent
        }
        this.isLoaded = true
    }
  }
}
</script>
